<script lang="ts">
	import type { Boat } from '../api';
	import Icon from './Icon.svelte';

	let {
		isOpen,
		boat,
		onClose,
		onEdit,
		onDelete
	}: {
		isOpen: boolean;
		boat: Boat | null;
		onClose: () => void;
		onEdit: (boat: Boat) => void;
		onDelete: (boat: Boat) => void;
	} = $props();

	function handleEdit() {
		if (boat) {
			onEdit(boat);
		}
	}

	function handleDelete() {
		if (boat) {
			onClose();
			onDelete(boat);
		}
	}
</script>

{#if isOpen && boat}
	<div class="fixed inset-0 z-50 overflow-hidden">
		<div class="absolute inset-0 overflow-hidden">
			<div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
				<div class="pointer-events-auto relative w-screen max-w-md">
					<div class="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
						<div class="px-4 sm:px-6">
							<div class="flex items-start justify-between">
								<h2 class="text-xl font-semibold text-gray-900">Boat Details</h2>
								<div class="ml-3 flex h-7 items-center">
									<button
										type="button"
										onclick={onClose}
										class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
									>
										<span class="sr-only">Close panel</span>
										<Icon name="x" size={24} />
									</button>
								</div>
							</div>
						</div>
						<div class="relative mt-6 flex-1 px-4 sm:px-6">
							<div class="space-y-6">
								<!-- Boat Name -->
								<div>
									<h3
										class="rounded-md border-0 bg-gray-50 px-3 py-1.5 text-lg font-medium text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300"
									>
										{boat.name}
									</h3>
									{#if boat.model}
										<p class="mt-1 text-sm text-gray-500">
											{boat.model}
										</p>
									{/if}
								</div>

								<!-- Boat Information -->
								<div class="space-y-4">
									{#if boat.brand}
										<div>
											<h4 class="text-sm font-medium text-gray-900">Brand</h4>
											<p class="mt-1 flex items-center gap-1 text-sm text-gray-600">
												<Icon name="tag" size={16} />
												{boat.brand}
											</p>
										</div>
									{/if}

									{#if boat.model}
										<div>
											<h4 class="text-sm font-medium text-gray-900">Model</h4>
											<p class="mt-1 flex items-center gap-1 text-sm text-gray-600">
												<Icon name="anchor" size={16} />
												{boat.model}
											</p>
										</div>
									{/if}

									{#if boat.sailNumber}
										<div>
											<h4 class="text-sm font-medium text-gray-900">Sail Number</h4>
											<p class="mt-1 flex items-center gap-1 text-sm text-gray-600">
												<Icon name="hash" size={16} />
												{boat.sailNumber}
											</p>
										</div>
									{/if}

									{#if boat.owners && boat.owners.length > 0}
										<div>
											<h4 class="text-sm font-medium text-gray-900">Owner(s)</h4>
											<div class="mt-1 space-y-2">
												{#each boat.owners as owner (owner.id)}
													<div class="flex items-center gap-2">
														<Icon name="users" size={16} />
														<button
															onclick={() => (window.location.href = `/users/${owner.id}`)}
															class="text-blue-600 hover:text-blue-800 hover:underline"
														>
															{owner.firstName}
															{owner.lastName}
														</button>
														{#if owner.email}
															<span class="text-xs text-gray-400">({owner.email})</span>
														{/if}
													</div>
												{/each}
											</div>
										</div>
									{/if}
								</div>

								<!-- Actions -->
								<div class="border-t border-gray-200 pt-4">
									<h4 class="mb-3 text-sm font-medium text-gray-900">Actions</h4>
									<div class="space-y-2">
										<button
											onclick={handleEdit}
											class="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
										>
											<Icon name="pencil" size={16} />
											Edit Boat
										</button>
										<button
											onclick={handleDelete}
											class="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
										>
											<Icon name="trash" size={16} />
											Delete Boat
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
{/if}
